module.exports = __webpack_public_path__ + "media/images/seller_testimonials-f99a928a5159438b5f387f99a9461c6a.svg";